import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {UserSubscription, UserSubscriptionType, UserSubscriptionCategory} from "../../../user/user-subscription";
import {UserSubscriptionStatus} from "../../../user/user-subscription-status";
import {User} from "../../../user/user";
import {IPlanDescriptionInstance} from "../../../user/plan-description/plan-description";
import {filter, first} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {Subscription} from "rxjs";
import * as fromStore from '../../../store';


@Component({
    selector: 'db-plan-label',
    templateUrl: './db-plan-label.component.html',
    styleUrls: ['./db-plan-label.component.scss'],
    standalone: false
})
export class DbPlanLabelComponent implements OnInit, OnDestroy {

  @Input() userSubscription: UserSubscription;
  @Input() user: User;
  @Input() _trialDeleteDay: any;
  @Input() trialDeleteDay: any;
  @Input() userSubscriptionStorage: number;
  @Input() userSubscriptionVisits: number;
  @Input() booster: boolean;
  public UserSubscriptionCategory: any = UserSubscriptionCategory;
  public userSubscriptionStatus: any = UserSubscriptionStatus;
  public UserSubscriptionType: any = UserSubscriptionType;
  public planDescriptionInstance: IPlanDescriptionInstance;
  public _pluginTitle: any;
  private subscriptions: Subscription[];


  constructor(
    private _store: Store<fromStore.DbStoreState>,
  ) {}

  ngOnInit() {
    this.addEventHandlers();
    if (this.userSubscription && this.userSubscription.type === this.UserSubscriptionType.ONE_PRODUCT) {
      this.planDescriptionInstance = this.userSubscription ? this.userSubscription.plan.description.getFeatures(this.userSubscription.productSlug) : null;
    }
  }

  private addEventHandlers(): void {
    this.subscriptions = [];

    this.subscriptions.push(
      this._store.select(fromStore.getTenWebProductsLoaded)
        .pipe(
          filter((loaded: boolean) => loaded),
          first()
        )
        .subscribe(() => {
          this._store.select(fromStore.getTenWebProducts)
            .pipe(first())
            .subscribe((products: any[]) => {
              this._pluginTitle = this.userSubscription && this.userSubscription.productSlug ? (products.find((product) => product.slug === this.userSubscription.productSlug)).title : '';
            });
        })
    );
  }

  ngOnDestroy(): void {
    this.removeEventHandlers();
  }

  private removeEventHandlers(): void {
    this.subscriptions.forEach((subscription: Subscription): void => {
      subscription.unsubscribe();
    });
    this.subscriptions = null;
  }

}
